export const analytic = (type,data) =>{
    window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //     'event': type,
    //     ...(type == 'send_message') && {'bot_name': data.bot_name},
    //     ...(type == 'share_event') && {'share_type': data.share_type},
    //     ...(type == 'app_invokation') && {'parent_domain': data.parent_domain},
    // })

    if(window?.gtag instanceof Function){
        window?.gtag('event', type, {
            ...(type == 'send_message') && {'bot_name': data.bot_name},
            ...(type == 'share_event') && {'share_type': data.share_type},
            ...(type == 'app_invokation') && {'parent_domain': data.parent_domain},
            ...(type == 'change_language') && {'language': data.language},
            ...(type == 'report_message') && {'reason': data.reason, 'message': data.message},
        })
    }

}